<template>
  <div class="wrapper-full">
    <!-- nibuts -->
    <Nibut
      v-if="subPage === DRYEYEMODES.nibut.key"
      :record="currentRecord"
      :currentEye="currentEye"
      @show-capture="showCapture"
    />
    <!-- 泪河 -->
    <TearHeight
      v-if="subPage === DRYEYEMODES.tearheight.key"
      :record="currentRecord"
      :currentEye="currentEye"
      @show-capture="showCapture"
    />
    <!-- 睑板腺 -->
    <Meibomian
      v-if="subPage === DRYEYEMODES.meibomian.key"
      :language="language"
      :record="currentRecord"
      :currentEye="currentEye"
      @show-capture="showCapture"
    />
    <!-- 脂质层 -->
    <LipidLayer
      v-if="subPage === DRYEYEMODES.lipidlayer.key"
      :record="currentRecord"
      :currentEye="currentEye"
      @show-capture="showCapture"
    />
    <!-- 眼红 -->
    <EyeRedness
      v-if="subPage === DRYEYEMODES.eyeredness.key"
      :record="currentRecord"
      :currentEye="currentEye"
      @show-capture="showCapture"
    />
    <!-- 睑缘 -->
    <EyeLidEdge
      v-if="subPage === DRYEYEMODES.eyelidedge.key"
      :record="currentRecord"
      :currentEye="currentEye"
      @show-capture="showCapture"
    />
    <!-- But -->
    <But
      v-if="subPage === DRYEYEMODES.fbut.key"
      :record="currentRecord"
      :currentEye="currentEye"
      @show-capture="showCapture"
    />
    <!-- 眨眼 -->
    <Blink
      v-if="subPage === DRYEYEMODES.blink.key"
      :language="language"
      :record="currentRecord"
      :currentEye="currentEye"
      @show-capture="showCapture"
    />
    <!-- 眼表 -->
    <Ocularsurface
      v-if="subPage === DRYEYEMODES.ocularsurface.key"
      :record="currentRecord"
      :currentEye="currentEye"
      @show-capture="showCapture"
    />
    <!-- 打印报告 -->
    <RecordList
      v-if="subPage === 'report'"
      :currentPatient="currentPatient"
      :currentEye="currentEye"
      :currentRecord="currentRecord"
      :recordsContent="recordsContent"
    />
  </div>
</template>
<script>
import { Message, Size, SubPageSize } from "../mixins";
import Nibut from "./components/Nibut";
import TearHeight from "./components/TearHeight";
import Meibomian from "./components/Meibomian";
import LipidLayer from "./components/LipidLayer";
import EyeRedness from "./components/EyeRedness";
import EyeLidEdge from "./components/EyeLidEdge";
import But from "./components/But";
import Blink from "./components/Blink";
import Ocularsurface from "./components/Ocularsurface";
import RecordList from "./components/RecordList";
import EVENTS from "../bus";
import { DRYEYEMODES } from "../shared/consts";
import { isDefined, logStdout } from "../shared/utils";
import { DryEye3rd } from "../topography/js/thirdparty";
import { updateRecord } from "../services/record";
export default {
  name: "DryEye",
  mixins: [Size, SubPageSize, Message],
  data() {
    return {
      isDebug: true,
      DRYEYEMODES: DRYEYEMODES
    };
  },
  components: {
    Nibut,
    TearHeight,
    Meibomian,
    LipidLayer,
    EyeRedness,
    EyeLidEdge,
    But,
    Blink,
    Ocularsurface,
    RecordList
  },
  watch: {
    subPage() {}
  },
  props: {
    subPage: {
      type: String,
      default: "nibut"
    },
    currentPatient: {
      type: Object,
      default: undefined
    },
    recordsContent: {
      type: Array,
      default: () => {
        return [];
      }
    },
    currentRecord: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentEye: {
      type: String,
      default: "OS"
    },
    language: {
      type: String,
      default: ""
    }
  },
  created() {
    this.$bus.$on(
      EVENTS.uploadingThirdyParty,
      (currentDryeye, record, text = false, file = false) => {
        if (
          window.thirdPartySettings &&
          window.thirdPartySettings.auto.value &&
          window.thirdpartyScript &&
          this.currentPatient.thirdData
        ) {
          this.currentRecord = isDefined(record) ? record : this.currentRecord;
          if (currentDryeye === "meibomian" || currentDryeye === "eyelidedge") {
            let up = false;
            let down = false;
            if (
              isDefined(
                this.currentRecord.content[`data${this.currentEye}`][currentDryeye]["up"]
              ) &&
              isDefined(
                this.currentRecord.content[`data${this.currentEye}`][currentDryeye]["up"].uploaded
              ) &&
              !text &&
              !file
            ) {
              up = true;
            }
            if (
              isDefined(
                this.currentRecord.content[`data${this.currentEye}`][currentDryeye]["down"]
              ) &&
              isDefined(
                this.currentRecord.content[`data${this.currentEye}`][currentDryeye]["down"].uploaded
              ) &&
              !text &&
              !file
            ) {
              down = true;
            }
            if (up && down) {
              return;
            }
          }
          if (
            this.currentRecord.content[`data${this.currentEye}`][currentDryeye].uploaded &&
            !text &&
            !file
          ) {
            return;
          }
          this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtUpload2server"));
          let dryeye3rd = new DryEye3rd(this.currentRecord, this.currentEye);
          dryeye3rd.normalDryEyeData(
            this.currentRecord,
            currentDryeye,
            text,
            (error, data, imgs) => {
              if (error) {
                this.message("create dryeye3rd data failed", "error");
                this.$bus.$emit(EVENTS.hideGlobalWatting);
                logStdout("create dryeye3rd failed", error);
                return;
              }
              logStdout(`dryeye3rd ${currentDryeye} data:`, data);
              logStdout(`dryeye3rd ${currentDryeye} imgs:`, imgs);
              window.thirdpartyScript.sendDryeyeData(
                this.currentPatient,
                isDefined(record) ? record : this.currentRecord,
                this.currentEye,
                {
                  params: data,
                  imgs: imgs ? imgs : {}
                },
                (res) => {
                  if (res.code === 200) {
                    this.$bus.$emit(EVENTS.hideGlobalWatting);
                    this.message(res.message, res.code === 200 ? "success" : "error");
                    if (currentDryeye === "meibomian" || currentDryeye === "eyelidedge") {
                      if (
                        isDefined(
                          this.currentRecord.content[`data${this.currentEye}`][currentDryeye]
                        ) &&
                        this.currentRecord.content[`data${this.currentEye}`][currentDryeye]["up"]
                      ) {
                        this.currentRecord.content[`data${this.currentEye}`][currentDryeye][
                          "up"
                        ].uploaded = true;
                      }
                      if (
                        isDefined(
                          this.currentRecord.content[`data${this.currentEye}`][currentDryeye]
                        ) &&
                        this.currentRecord.content[`data${this.currentEye}`][currentDryeye]["down"]
                      ) {
                        this.currentRecord.content[`data${this.currentEye}`][currentDryeye][
                          "down"
                        ].uploaded = true;
                      }
                      this.currentRecord.content[`data${this.currentEye}`].inspectId =
                        res.inspectId;
                    } else {
                      this.currentRecord.content[`data${this.currentEye}`].inspectId =
                        res.inspectId;
                      this.currentRecord.content[`data${this.currentEye}`][currentDryeye].uploaded =
                        true;
                    }
                    updateRecord(this.currentRecord);
                  } else {
                    this.$bus.$emit(EVENTS.hideGlobalWatting);
                    this.message(res.message, "error");
                  }
                }
              );
            }
          );
        }
      }
    );
    this.$bus.$on("errorText", (text) => {
      this.notify(text, "", "error");
    });
  },
  mounted() {
    // this.$emit('select')
    if (!this.currentPatient.thirdData) {
      this.$bus.$emit(EVENTS.hideGlobalWatting);
    }
  },
  destroyed() {
    this.$bus.$off(EVENTS.uploadingThirdyParty);
  },
  methods: {
    showCapture(mode, upDown) {
      this.$emit("show-capture", "dryeye", mode, upDown);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/dryeye/DryEye.vue